// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f72a07d6","453":"a9caab02","732":"2b63bc5e"}[chunkId] + ".chunk.js";
};